import { useQuery } from '@tanstack/react-query';
import { GET_SOURCES_STATS_FOR_DOMAIN } from '../../../../query/monitor/data/sources/keys';
import {
  getSourcesStatsForDomain,
  DomainSourcesStatsResponse,
} from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';

export const useGetSourcesStatsForDomain = (
  projectId: number | null,
  domain: string,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  page?: number,
  pageSize?: number,
  keyword?: string,
  mentioned?: boolean,
  sortBy?: string,
  sortOrder?: string,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!domain && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: domainSourcesStats,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<DomainSourcesStatsResponse>({
    queryKey: [
      GET_SOURCES_STATS_FOR_DOMAIN,
      projectId,
      domain,
      chatType,
      fromTimestamp,
      toTimestamp,
      page,
      pageSize,
      keyword,
      mentioned,
      sortBy,
      sortOrder,
      monitorPromptIds,
      filterMonitorTypes,
    ],
    queryFn: () =>
      getSourcesStatsForDomain(projectId!, domain, chatType!, from, to, page, pageSize, keyword, mentioned, sortBy, sortOrder, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  const empty: DomainSourcesStatsResponse = { sources: [], totalCount: 0 };

  return {
    domainSourcesStats: queryEnabled ? domainSourcesStats ?? empty : empty,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
  };
};
